import { produce } from 'immer';

var initialState = {
  links: [],
  loading: false,
  error: null
};
var reducer = function reducer(state, _ref, duck) {
  var type = _ref.type,
    payload = _ref.payload,
    error = _ref.error;
  return produce(state, function (draftState) {
    switch (type) {
      case duck.types.GET_SOCIAL_LINKS:
        draftState.error = initialState.error;
        draftState.loading = true;
        break;
      case duck.types.CREATE_LINK:
      case duck.types.UPDATE_LINK:
      case duck.types.DELETE_LINK:
        draftState.error = initialState.error;
        draftState.loading = true;
        break;
      case duck.types.GET_SOCIAL_LINKS_SUCCESS:
        draftState.links = payload;
        draftState.loading = false;
        break;
      case duck.types.GET_SOCIAL_LINKS_ERROR:
      case duck.types.CREATE_LINK_ERROR:
      case duck.types.UPDATE_LINK_ERROR:
      case duck.types.DELETE_LINK_ERROR:
        draftState.error = error;
        draftState.loading = false;
        break;
      // do nothing
    }
  });
};

export { reducer as default, initialState };
//# sourceMappingURL=reducer.js.map
